import { ValueLabelResponse } from 'types';

export const sortValueLabel = (a: ValueLabelResponse, b: ValueLabelResponse): number =>
  a.label > b.label ? 1 : -1;
